import React, { useEffect, useState } from 'react';
import apiHandler from '../../common/api';
import { useParams } from 'react-router-dom';
import CommonMaterialReactTable from '../../MaterialReactTable/CommonMaterialReactTable';
import LoadingSpinner from '../../../InitialPage/Sidebar/LoadingSpinner';


const InvoiceDetail = () => {
    const params = useParams();
    const [invoiceList, setInvoiceList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summaryInfo, setSummaryInfo] = useState(null);

    const columns = [
        {
            header: '#',
            accessorKey: 'rowNum',
            size: 60,
            Cell: ({ row }) => <span>{row.index + 1}</span>,
        },
        {
            header: 'Customer Name',
            accessorKey: 'customerName',
            enableSorting: true,
            sortingFn: 'alphanumeric',
        },
        {
            header: 'Appointment Date',
            accessorKey: 'appointmentdate',
            enableSorting: true,
            sortingFn: 'alphanumeric',
            Cell: ({ row }) => (
                <span>
                    {row.original.appointmentdate
                        ? new Date(row.original.appointmentdate).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        })
                        : '—'}
                </span>
            ),
        },
        {
            header: 'Amount ($)',
            accessorKey: 'appointmentamount',
            enableSorting: true,
            sortingFn: 'numeric',
            Cell: ({ row }) => (
                <span className="fw-semibold text-success">
                    ${parseFloat(row.original.appointmentamount || 0).toFixed(2)}
                </span>
            ),
        },
        {
            header: 'Commission ',
            accessorKey: 'commision',
            enableSorting: true,
            sortingFn: 'numeric',
            Cell: ({ row }) => (
                <span >${parseFloat(row.original.commision || 0).toFixed(2)}</span>
            ),
        },

    ];

    const fetchInvoiceData = async () => {
        setLoading(true);
        try {
            const response = await apiHandler({
                method: 'GET',
                route: `Business/getinvoicebyid?InvoiceId=${params.id}`,
            });
            if (response?.ResponseCode === 'SUCCESS') {
                const data = response.ResponseData?.Data || [];
                setInvoiceList(data);
                if (data.length > 0) {
                    const totalAmount = data.reduce(
                        (sum, item) => sum + parseFloat(item.appointmentamount || 0),
                        0
                    );
                    const totalCommission = data.reduce((sum, item) => {

                        const pct = parseFloat(item.commision || 0);
                        return sum + pct;
                    }, 0);
                    setSummaryInfo({
                        businessName: data[0].businessUniqueName,
                        totalAppointments: data.length,
                        totalAmount: totalAmount.toFixed(2),
                        totalCommission: totalCommission.toFixed(2),
                    });
                }
            }
        } catch (err) {
            console.error('Invoice fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvoiceData();
    }, []);

    return (
        <>
            <LoadingSpinner isLoading={loading} />
            <div className="page-wrapper">
                <div className="content">


                    {/* Summary Cards */}
                    {summaryInfo && (
                        <div className="row mb-4">
                            <div className="col-12 mb-3">
                                <h5 className="text-muted fw-semibold">
                                    <i className="ti ti-building-store me-2"></i>
                                    Business: <span className="text-dark">{summaryInfo.businessName}</span>
                                </h5>
                            </div>
                            <div className="col-xl-4 col-sm-6 mb-3">
                                <div className="card h-100 border-0 shadow-sm">
                                    <div className="card-body d-flex align-items-center gap-3">
                                        <div
                                            className="rounded-circle d-flex align-items-center justify-content-center"
                                            style={{
                                                width: 52,
                                                height: 52,
                                                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                                                flexShrink: 0,
                                            }}
                                        >
                                            <i className="ti ti-calendar-event text-white fs-4"></i>
                                        </div>
                                        <div>
                                            <p className="text-muted mb-0 small">Total Appointments</p>
                                            <h4 className="mb-0 fw-bold">{summaryInfo.totalAppointments}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-sm-6 mb-3">
                                <div className="card h-100 border-0 shadow-sm">
                                    <div className="card-body d-flex align-items-center gap-3">
                                        <div
                                            className="rounded-circle d-flex align-items-center justify-content-center"
                                            style={{
                                                width: 52,
                                                height: 52,
                                                background: 'linear-gradient(135deg, #11998e, #38ef7d)',
                                                flexShrink: 0,
                                            }}
                                        >
                                            <i className="ti ti-currency-dollar text-white fs-4"></i>
                                        </div>
                                        <div>
                                            <p className="text-muted mb-0 small">Total Amount</p>
                                            <h4 className="mb-0 fw-bold text-success">${summaryInfo.totalAmount}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-sm-6 mb-3">
                                <div className="card h-100 border-0 shadow-sm">
                                    <div className="card-body d-flex align-items-center gap-3">
                                        <div
                                            className="rounded-circle d-flex align-items-center justify-content-center"
                                            style={{
                                                width: 52,
                                                height: 52,
                                                background: 'linear-gradient(135deg, #f093fb, #f5576c)',
                                                flexShrink: 0,
                                            }}
                                        >
                                            <i className="ti ti-percentage text-white fs-4"></i>
                                        </div>
                                        <div>
                                            <p className="text-muted mb-0 small">Total Commission</p>
                                            <h4 className="mb-0 fw-bold text-warning">${summaryInfo.totalCommission}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Invoice Table */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <CommonMaterialReactTable
                                    columns={columns}
                                    data={invoiceList}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InvoiceDetail;